import { ICPlatformVersion } from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const legacyOrdersDeliveryAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.OrdersDelivery],
    maxICPlatformVersionExclusive: ICPlatformVersion.r2026_11_0,
  },
  // Access control for only J&T (3rd party contractor) to access Delivery orders
  {
    permissions: [Permission.OrdersDelivery],
    featureToggles: [FeatureToggle.LegacyOrdersRestrictedAccess],
    restrictedBannersAllowed: true,
    maxICPlatformVersionExclusive: ICPlatformVersion.r2026_11_0,
  },
]

export const legacyOrdersPickupAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.OrdersPickup],
    maxICPlatformVersionExclusive: ICPlatformVersion.r2026_11_0,
  },
  // Access control for only J&T (3rd party contractor) to access Pickup orders
  {
    permissions: [Permission.OrdersPickup],
    featureToggles: [FeatureToggle.LegacyOrdersRestrictedAccess],
    restrictedBannersAllowed: true,
    maxICPlatformVersionExclusive: ICPlatformVersion.r2026_11_0,
  },
]

export const legacyOrdersDeliveryPartnerScopedAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.OrdersDelivery],
    minICPlatformVersion: ICPlatformVersion.r2026_11_0,
  },
  {
    permissions: [Permission.OrdersDelivery],
    featureToggles: [FeatureToggle.LegacyOrdersRestrictedAccess],
    restrictedBannersAllowed: true,
    minICPlatformVersion: ICPlatformVersion.r2026_11_0,
  },
]

export const legacyOrdersPickupPartnerScopedAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.OrdersPickup],
    minICPlatformVersion: ICPlatformVersion.r2026_11_0,
  },
  {
    permissions: [Permission.OrdersPickup],
    featureToggles: [FeatureToggle.LegacyOrdersRestrictedAccess],
    restrictedBannersAllowed: true,
    minICPlatformVersion: ICPlatformVersion.r2026_11_0,
  },
]
